import React, { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { Link, useHistory } from 'react-router-dom'
import Logo from '../image/logo/logo-liberhash.png'
import { Alert } from 'react-bootstrap'

export default function Header() {

    const { logout } = useAuth()
    const [error, setError] = useState('')
    const history = useHistory()

    async function handleLogout(){
        setError('')

        try{
            await logout()
            history.push('/login')
        } catch {
            setError('Falla en cerrar sesión')
        }
    }


    return (
        <header className="header py-3 mb-3 px-2 border-bottom bg-white container-fluid">
        <div className="container d-grid gap-3 align-items-center" style={{gridTemplateColumns: '1fr 2fr'}}>
            <div className="menu">
                <Link to="/" className="d-flex align-items-center col-lg-4 mb-2 mb-lg-0 link-dark text-decoration-none" aria-expanded="false">
                    <img src={Logo}  alt="Logo LiberHash" className="img-fluid" />
                </Link>
            </div>
            <div className="d-flex align-items-center justify-content-end px-4">
                <button className="btn btn-link border-0 text-decoration-none" style={{color: '#ffa900'}} onClick={handleLogout}>Cerrar Sesión</button>
                <Link to="/update-profile"  className="btn btn-warning" style={{color: '#fff'}}>Perfil</Link>
            </div>
        </div>
        {error && <Alert variant="danger">{error}</Alert>}
    </header>
    )
}
